/* ÉLUMÉ Classic Konfigurator
   Live-Vorschau der Karte und Erzeugung der Druck-PDF beim „In den Warenkorb“. */
(function () {
  const root = document.querySelector(".elk");
  if (!root) return;

  const CARDS = [
    { id: "sage", name: "Sage Green", color: "#5E7253" },
    { id: "ivory", name: "Ivory", color: "#E9DFCC" },
  ];
  const COLORS = [
    { id: "rosa", name: "Rosa", hex: "#F6D3E4" }, { id: "beige", name: "Beige", hex: "#F8EEDC" },
    { id: "braun", name: "Braun", hex: "#5A3A2E" }, { id: "gruen", name: "Grün", hex: "#8FA27E" },
    { id: "gold", name: "Gold", hex: "#C9A13E" }, { id: "weiss", name: "Weiß", hex: "#FFFFFF" },
    { id: "schwarz", name: "Schwarz", hex: "#151515" },
  ];
  const SOLIDS = [
    { id: "ivory", name: "Ivory", hex: "#F3EEE3" }, { id: "green", name: "Green", hex: "#7D9A78" },
    { id: "beige", name: "Beige", hex: "#D8C6AE" }, { id: "rose", name: "Rose", hex: "#EACFCB" },
    { id: "gold", name: "Gold", hex: "#C9A548" }, { id: "schwarz", name: "Schwarz", hex: "#111111" },
  ];
  const FONTS = [
    { id: 1, name: "Schrift 1", css: "'Cantarell', sans-serif", w: 400, scale: .9 },
    { id: 2, name: "Schrift 2", css: "'Original Surfer', cursive", w: 400, scale: .9 },
    { id: 3, name: "Schrift 3", css: "'Italianno', cursive", w: 400, scale: 1.4 },
    { id: 4, name: "Schrift 4", css: "'Cormorant Garamond', serif", w: 500, scale: 1 },
    { id: 5, name: "Schrift 5", css: "'Archivo Black', sans-serif", w: 400, scale: .78 },
  ];
  const TEXTS = [
    { k: "title", name: "Titel", max: 25, factor: .19, multi: false, sizes: [45, 65, 75, 95],
      def: { text: "", font: 3, size: 65, color: "braun" }, ph: "z. B. Alles Liebe" },
    { k: "sub", name: "Untertitel", max: 40, factor: .11, multi: false, sizes: [40, 60, 70, 90],
      def: { text: "", font: 4, size: 60, color: "braun" }, ph: "z. B. zum Geburtstag" },
    { k: "msg", name: "Text", max: 500, factor: .1, multi: true, sizes: [40, 60, 70, 90],
      def: { text: "", font: 4, size: 40, color: "schwarz" }, ph: "Deine persönliche Botschaft" },
  ];
  // Textvorschläge für die persönliche Botschaft
  const SUGGESTIONS = [
    { name: "Jahrestag", text: "Ein weiteres Jahr voller gemeinsamer Momente, leiser Gesten und großer Gefühle. Danke für jedes Lachen, jede Umarmung und jeden ganz normalen Tag, der mit dir besonders wird.\n\nAuf alles, was noch kommt." },
    { name: "Weihnachten", text: "In der Zeit der Lichter sollst du wissen, wie hell du dieses Jahr gemacht hast. Frohe Weihnachten – voller Wärme, Ruhe und Momente, die bleiben." },
    { name: "Geburtstag", text: "Heute wird gefeiert, was dich so besonders macht: dein Lachen, dein Herz, deine Art. Möge dein neues Lebensjahr voller Licht, Abenteuer und wunderbarer Menschen sein.\n\nAlles Liebe zum Geburtstag!" },
    { name: "Von Herzen", text: "Manche Pfoten hinterlassen Spuren, die niemals verblassen. Deine treue Fellnase war Freund, Familie und ein Stück Zuhause – und lebt in jeder Erinnerung weiter.\n\nIn stiller Verbundenheit." },
    { name: "Hochzeit", text: "Heute beginnt euer schönstes Kapitel. Möge eure Liebe euch durch alle Jahreszeiten tragen – mit Geduld in stillen Momenten und Freude in den lauten.\n\nVon Herzen alles Gute für euren gemeinsamen Weg." },
  ];
  const TPLS = [
    { id: "own", name: "Eigenes Foto" },
    { id: "baby-sage", name: "Baby Salbei", file: "baby-salbei" },
    { id: "baby-rose", name: "Baby Rosa", file: "baby-rosa" },
    { id: "wedding", name: "Hochzeit", file: "hochzeit" },
    { id: "paws", name: "Pfoten", file: "pfoten" },
    { id: "xmas", name: "Weihnachten", file: "weihnachten" },
  ];
  const tplUrl = (t) => root.dataset["bg" + t.file.replace(/(^|-)(\w)/g, (m, d, c) => c.toUpperCase())];
  const SIDES = {
    L: { name: "links", hint: "Dein Foto füllt die ganze linke Seite. Dahinter sitzt das LED-Licht, helle Motive leuchten am schönsten." },
    R: { name: "rechts", hint: "Dein Foto füllt die ganze rechte Seite, die Texte liegen darüber. Wähle eine Textfarbe, die sich gut abhebt." },
  };
  // Druck-PDF (Backlight-Folie): 115 × 170 mm, Foto 98 × 134 mm, Ränder oben 6, unten 30, seitlich 8,5 mm, unbedruckt
  const PRINT = { pageW: 115, pageH: 170, x: 8.5, y: 6, w: 98, h: 134, dpi: 300, markLen: 6 };
  const mmToPx = (mm) => Math.round(mm / 25.4 * PRINT.dpi);
  // Referenznummer für Druckerei und Bestellung, z. B. ELK-7F3K2Q (ohne leicht verwechselbare Zeichen)
  function makeRef() {
    const abc = "23456789ABCDEFGHJKLMNPQRSTUVWXYZ", r = new Uint32Array(6);
    crypto.getRandomValues(r);
    return "ELK-" + Array.from(r, n => abc[n % abc.length]).join("");
  }
  const DEFAULT_POS = { title: { x: 50, y: 25 }, sub: { x: 50, y: 36 }, msg: { x: 50, y: 62 } };

  const state = {
    card: "sage",
    bg: { L: "own", R: "own" },
    photo: { L: null, R: null },   // { id, src, name, w, h, scale, ox, oy } – scale 1 = füllt den Druck, ox/oy in % der Seite
    title: { ...TEXTS[0].def }, sub: { ...TEXTS[1].def }, msg: { ...TEXTS[2].def },
    pos: JSON.parse(JSON.stringify(DEFAULT_POS)),
    view: "spread", light: false,
  };

  const q = (sel) => root.querySelector(sel);
  const qa = (sel) => root.querySelectorAll(sel);
  const card = () => CARDS.find(c => c.id === state.card);
  const colorObj = (id) => COLORS.find(c => c.id === id);
  const fontObj = (id) => FONTS.find(f => f.id === id);
  const solidOf = (bg) => bg.startsWith("solid-") ? SOLIDS.find(s => "solid-" + s.id === bg) : null;
  const tplOf = (bg) => TPLS.find(t => t.id === bg);
  const esc = (s) => String(s).replace(/[&<>"]/g, ch => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[ch]));
  function bgLabel(s) {
    const bg = state.bg[s], solid = solidOf(bg);
    if (bg === "own") return "Eigenes Foto";
    if (solid) return "Einfarbig " + solid.name;
    return "Vorlage " + tplOf(bg).name;
  }

  function buildOptions(el, items, render, isSel, onPick, cls = "") {
    el.innerHTML = "";
    items.forEach(item => {
      const b = document.createElement("button");
      b.type = "button"; b.className = "elk-opt " + cls;
      b.innerHTML = render(item);
      b.addEventListener("click", () => { onPick(item); update(); });
      b._sel = () => isSel(item);
      el.appendChild(b);
    });
  }

  // Foto-Geometrie in % der Druckfläche (98 × 134 mm)
  const PAGE_A = PRINT.w / PRINT.h;
  function photoBox(p) {
    const a = p.w / p.h;
    let bw = 100, bh = 100;
    if (a > PAGE_A) bw = a / PAGE_A * 100; else bh = PAGE_A / a * 100;
    bw *= p.scale; bh *= p.scale;
    return { l: 50 + p.ox - bw / 2, t: 50 + p.oy - bh / 2, w: bw, h: bh };
  }
  // Teile des Fotos liegen außerhalb der Druckfläche und werden abgeschnitten (kleine Toleranz für Rundung)
  const photoCrops = (p) => { const b = photoBox(p), e = .5; return b.l < -e || b.t < -e || b.l + b.w > 100 + e || b.t + b.h > 100 + e; };
  const photoFits = (p) => { const b = photoBox(p), e = .15; return b.l <= e && b.t <= e && b.l + b.w >= 100 - e && b.t + b.h >= 100 - e; };
  let photoId = 0;

  function buildSide(s) {
    const box = q(`[data-side="${s}"]`);
    const own = s === "L";   // links nur eigenes Foto
    box.innerHTML = (own ? "" : `
      <div class="elk-group">
        <div class="elk-group-head"><span class="elk-label">Hintergrund ${SIDES[s].name}</span><span class="elk-chosen" data-chosen-bg="${s}"></span></div>
        <div class="elk-opts elk-tiles" data-opts-bg="${s}"></div>
      </div>`) + `
      <div class="elk-group" data-photo-group="${s}">
        <div class="elk-upload-row">
          <label class="elk-upload"><input type="file" accept="image/jpeg,image/png,image/heic,image/webp" data-photo-input="${s}">Foto auswählen</label>
          <span class="elk-filename" data-photo-name="${s}"></span>
          <button class="elk-link" type="button" data-photo-remove="${s}">Entfernen</button>
        </div>
        <p class="elk-warn" data-photo-error="${s}" hidden></p>
        <div class="elk-group" data-photo-tools="${s}">
          <div class="elk-group-head"><span class="elk-label">Fotogröße</span><button class="elk-link" type="button" data-photo-fit="${s}">Einpassen</button></div>
          <div class="elk-zoom"><input type="range" min="50" max="300" step="1" value="100" data-photo-zoom="${s}" aria-label="Fotogröße ${SIDES[s].name}"><span class="elk-zoom-val" data-photo-zoom-val="${s}">100 %</span></div>
          <p class="elk-hint">Ziehe das Foto in der Vorschau, um den Ausschnitt zu verschieben.</p>
          <p class="elk-warn elk-notice" data-photo-crop="${s}" hidden>Ein Teil Deines Fotos liegt außerhalb des Rahmens und wird abgeschnitten. Verkleinere oder verschiebe es, falls dabei etwas Wichtiges fehlt.</p>
          <p class="elk-warn" data-photo-gap="${s}" hidden>Das Foto füllt den Rahmen nicht ganz aus. Vergrößere oder verschiebe es, bis keine leeren Ränder mehr zu sehen sind.</p>
        </div>
        <p class="elk-warn" data-photo-warn="${s}" hidden></p>
        <p class="elk-hint">${SIDES[s].hint}</p>
      </div>` + (own ? "" : `
      <div class="elk-group">
        <span class="elk-label">Einfarbig</span>
        <div class="elk-opts elk-swatches" data-opts-solid="${s}"></div>
      </div>`);
    if (!own) {
      buildOptions(q(`[data-opts-bg="${s}"]`), TPLS,
      t => `<span class="elk-thumb${t.id === "own" ? " elk-own" : ""}" data-thumb="${t.id}">${t.id === "own" ? "+" : ""}</span><span class="elk-cap">${t.name}</span>`,
      t => state.bg[s] === t.id,
      t => { state.bg[s] = t.id; if (t.id === "own" && !state.photo[s]) q(`[data-photo-input="${s}"]`).click(); });
    buildOptions(q(`[data-opts-solid="${s}"]`), SOLIDS,
      c => `<span class="elk-dot" style="background:${c.hex}"></span><span class="elk-cap">${c.name}</span>`,
      c => state.bg[s] === "solid-" + c.id, c => state.bg[s] = "solid-" + c.id, "elk-swatch");
    }
    const err = q(`[data-photo-error="${s}"]`);
    q(`[data-photo-input="${s}"]`).addEventListener("change", e => {
      const f = e.target.files && e.target.files[0]; if (!f) return;
      const r = new FileReader();
      r.onload = () => {
        const im = new Image();
        im.onload = () => {
          if (im.naturalWidth > im.naturalHeight) {
            err.textContent = "Dieses Foto ist im Querformat. Bitte lade ein Foto im Hochformat hoch, damit es auf die Karte passt.";
            err.hidden = false; e.target.value = ""; return;
          }
          err.hidden = true;
          state.photo[s] = { id: ++photoId, src: r.result, name: f.name, w: im.naturalWidth, h: im.naturalHeight, scale: 1, ox: 0, oy: 0 };
          state.bg[s] = "own"; update();
        };
        im.onerror = () => { err.textContent = "Dieses Bild kann Dein Browser nicht öffnen. Bitte wähle ein Foto als JPG oder PNG."; err.hidden = false; e.target.value = ""; };
        im.src = r.result;
      };
      r.readAsDataURL(f);
    });
    q(`[data-photo-remove="${s}"]`).addEventListener("click", () => { state.photo[s] = null; q(`[data-photo-input="${s}"]`).value = ""; update(); });
    q(`[data-photo-zoom="${s}"]`).addEventListener("input", e => { const p = state.photo[s]; if (!p) return; p.scale = e.target.value / 100; placePhoto(s); });
    q(`[data-photo-fit="${s}"]`).addEventListener("click", () => { const p = state.photo[s]; if (!p) return; p.scale = 1; p.ox = 0; p.oy = 0; placePhoto(s); });
    // Foto in der Vorschau verschieben
    const pat = q(`[data-pat="${s}"]`);
    let start = null;
    pat.addEventListener("pointerdown", e => {
      const p = state.photo[s];
      if (state.bg[s] !== "own" || !p) return;
      start = { px: e.clientX, py: e.clientY, ox: p.ox, oy: p.oy, w: pat.offsetWidth, h: pat.offsetHeight };
      pat.setPointerCapture(e.pointerId); e.preventDefault();
    });
    pat.addEventListener("pointermove", e => {
      if (!start) return;
      const p = state.photo[s];
      p.ox = start.ox + (e.clientX - start.px) / start.w * 100;
      p.oy = start.oy + (e.clientY - start.py) / start.h * 100;
      placePhoto(s);
    });
    const end = () => { start = null; };
    pat.addEventListener("pointerup", end); pat.addEventListener("pointercancel", end);
  }

  // Foto-Position und -Größe anwenden, Warnung bei leeren Rändern
  function placePhoto(s) {
    const p = state.photo[s], img = q(`[data-pat="${s}"] .elk-photo-img`);
    const own = state.bg[s] === "own" && p;
    if (own && img) {
      const b = photoBox(p);
      Object.assign(img.style, { left: b.l + "%", top: b.t + "%", width: b.w + "%", height: b.h + "%" });
      q(`[data-photo-zoom="${s}"]`).value = Math.round(p.scale * 100);
      q(`[data-photo-zoom-val="${s}"]`).textContent = Math.round(p.scale * 100) + " %";
    }
    const gap = own && !photoFits(p);
    q(`[data-photo-gap="${s}"]`).hidden = !gap;
    q(`[data-photo-crop="${s}"]`).hidden = !(own && photoCrops(p));
    q(`[data-page="${s}"]`).parentElement.classList.toggle("elk-gap", !!gap);
  }

  function buildTexts() {
    q("[data-texts]").innerHTML = TEXTS.map(t => `
      <div class="elk-text-block">
        <h3 class="elk-sub-head">${t.name}</h3>
        ${t.k === "msg" ? `<div class="elk-group"><span class="elk-label">Textvorschlag (optional)</span><div class="elk-suggest" data-suggest></div><p class="elk-hint">Ein Klick übernimmt den Vorschlag ins Textfeld. Du kannst ihn danach frei anpassen.</p></div>` : ""}
        <div class="elk-group">
          ${t.multi
            ? `<textarea rows="5" maxlength="${t.max}" data-in="${t.k}" placeholder="${t.ph}" aria-label="${t.name}"></textarea>`
            : `<input type="text" maxlength="${t.max}" data-in="${t.k}" placeholder="${t.ph}" aria-label="${t.name}">`}
          <div class="elk-counter" data-cnt="${t.k}"></div>
          <p class="elk-warn" data-warn="${t.k}" hidden>${t.name} passt nicht vollständig auf die Karte. Wähle eine kleinere Größe oder kürze den Text.</p>
        </div>
        <div class="elk-group"><div class="elk-group-head"><span class="elk-label">Schriftart</span><span class="elk-chosen" data-chosen="${t.k}-font"></span></div><div class="elk-opts elk-tiles" data-o="${t.k}-font"></div></div>
        <div class="elk-group"><div class="elk-group-head"><span class="elk-label">Größe</span><span class="elk-chosen" data-chosen="${t.k}-size"></span></div><div class="elk-opts elk-sizes" data-o="${t.k}-size"></div></div>
        <div class="elk-group"><div class="elk-group-head"><span class="elk-label">Farbe</span><span class="elk-chosen" data-chosen="${t.k}-color"></span></div><div class="elk-opts elk-swatches" data-o="${t.k}-color"></div></div>
      </div>`).join("");
    TEXTS.forEach(({ k, sizes }) => {
      buildOptions(q(`[data-o="${k}-font"]`), FONTS,
        f => `<span class="elk-font-sample" style="font-family:${f.css};font-weight:${f.w}">Liebe</span><span class="elk-cap">${f.name}</span>`,
        f => state[k].font === f.id, f => state[k].font = f.id);
      buildOptions(q(`[data-o="${k}-size"]`), sizes, s => `<span>Größe ${s}</span>`, s => state[k].size === s, s => state[k].size = s);
      buildOptions(q(`[data-o="${k}-color"]`), COLORS, c => `<span class="elk-dot" style="background:${c.hex}"></span><span class="elk-cap">${c.name}</span>`,
        c => state[k].color === c.id, c => state[k].color = c.id, "elk-swatch");
      q(`[data-in="${k}"]`).addEventListener("input", e => { state[k].text = e.target.value; update(); });
    });
    const sug = q("[data-suggest]");
    SUGGESTIONS.forEach(sg => {
      const b = document.createElement("button");
      b.type = "button"; b.className = "elk-chip-btn"; b.textContent = sg.name;
      b.addEventListener("click", () => { state.msg.text = sg.text; q('[data-in="msg"]').value = sg.text; update(); });
      sug.appendChild(b);
    });
  }

  // Textboxen verschieben, Position in % des Drucks (98 × 134 mm)
  const outEl = (k) => q(`[data-out="${k}"]`);
  const pageR = () => q('[data-page="R"]');
  function clampPos(k) {
    const el = outEl(k), page = pageR(), p = state.pos[k];
    if (!page.offsetWidth || !el.offsetWidth) return;
    const mx = 2 / PRINT.w * 100 + .3, my = 1 / PRINT.h * 100 + .3;
    const hw = el.offsetWidth / page.offsetWidth * 50, hh = el.offsetHeight / page.offsetHeight * 50;
    p.x = hw + mx >= 50 ? 50 : Math.min(Math.max(p.x, hw + mx), 100 - hw - mx);
    p.y = hh + my >= 50 ? 50 : Math.min(Math.max(p.y, hh + my), 100 - hh - my);
  }
  function placeText(k) { const el = outEl(k); el.style.left = state.pos[k].x + "%"; el.style.top = state.pos[k].y + "%"; }
  function enableDrag(k) {
    const el = outEl(k);
    let start = null;
    el.addEventListener("pointerdown", e => {
      const page = pageR();
      start = { px: e.clientX, py: e.clientY, x: state.pos[k].x, y: state.pos[k].y, w: page.offsetWidth, h: page.offsetHeight };
      el.setPointerCapture(e.pointerId); el.classList.add("elk-dragging"); e.preventDefault();
    });
    el.addEventListener("pointermove", e => {
      if (!start) return;
      state.pos[k].x = start.x + (e.clientX - start.px) / start.w * 100;
      state.pos[k].y = start.y + (e.clientY - start.py) / start.h * 100;
      clampPos(k); placeText(k);
    });
    const end = () => { if (!start) return; start = null; el.classList.remove("elk-dragging"); };
    el.addEventListener("pointerup", end);
    el.addEventListener("pointercancel", end);
  }

  function styleText(el, cfg, factor) {
    const f = fontObj(cfg.font);
    el.style.fontFamily = f.css; el.style.fontWeight = f.w;
    el.style.fontSize = (cfg.size * factor * f.scale).toFixed(2) + "cqw";
    el.style.color = colorObj(cfg.color).hex;
    el.textContent = cfg.text;
  }

  function renderSide(s) {
    const bg = state.bg[s], p = state.photo[s], pat = q(`[data-pat="${s}"]`), solid = solidOf(bg);
    pat.classList.toggle("elk-photo", bg === "own" && !!p);
    if (bg === "own" && p) {
      pat.style.background = "#F4F2EE";
      let img = pat.querySelector(".elk-photo-img");
      if (!img) { pat.innerHTML = ""; img = document.createElement("img"); img.className = "elk-photo-img"; img.alt = ""; pat.appendChild(img); }
      if (img.dataset.pid !== String(p.id)) { img.src = p.src; img.dataset.pid = p.id; }
    } else {
      pat.innerHTML = "";
      if (bg === "own") { pat.style.background = "#F4F2EE"; pat.innerHTML = `<div class="elk-ph">Dein Foto<br>erscheint hier</div>`; }
      else if (solid) pat.style.background = solid.hex;
      else pat.style.background = `url("${tplUrl(tplOf(bg))}") center / cover no-repeat`;
    }
    q(`[data-photo-tools="${s}"]`).hidden = !p;
    placePhoto(s);

    qa(`[data-opts-bg="${s}"] [data-thumb]`).forEach(t => {
      if (t.dataset.thumb === "own") { t.style.background = p ? `url("${p.src}") center / cover` : ""; t.textContent = p ? "" : "+"; }
      else t.style.background = `url("${tplUrl(tplOf(t.dataset.thumb))}") center / cover`;
    });
    q(`[data-photo-group="${s}"]`).hidden = bg !== "own";
    q(`[data-photo-name="${s}"]`).textContent = p ? p.name : "Noch kein Foto";
    q(`[data-photo-remove="${s}"]`).hidden = !p;
    const warn = q(`[data-photo-warn="${s}"]`);
    const lowRes = p && (Math.max(p.w, p.h) < mmToPx(134) * .66 || Math.min(p.w, p.h) < mmToPx(98) * .66);
    warn.hidden = !lowRes;
    if (lowRes) warn.textContent = `Dein Foto hat eine geringe Auflösung (${p.w} × ${p.h} Pixel) und könnte unscharf gedruckt werden. Am besten mindestens ${mmToPx(98)} × ${mmToPx(134)} Pixel.`;
    const chosen = q(`[data-chosen-bg="${s}"]`);
    if (chosen) chosen.textContent = bgLabel(s);
  }

  function update() {
    const c = card();
    renderSide("L"); renderSide("R");
    TEXTS.forEach(t => {
      styleText(outEl(t.k), state[t.k], t.factor);
      placeText(t.k);
      q(`[data-cnt="${t.k}"]`).textContent = `${state[t.k].text.length}/${t.max}`;
      q(`[data-chosen="${t.k}-font"]`).textContent = fontObj(state[t.k].font).name;
      q(`[data-chosen="${t.k}-size"]`).textContent = "Größe " + state[t.k].size;
      q(`[data-chosen="${t.k}-color"]`).textContent = colorObj(state[t.k].color).name;
    });
    qa("button.elk-opt").forEach(b => b.setAttribute("aria-pressed", b._sel() ? "true" : "false"));
    q('[data-val="card"]').textContent = c.name;
    q('[data-val="left"]').textContent = bgLabel("L");
    q('[data-val="right"]').textContent = state.title.text || state.sub.text || bgLabel("R");

    const spread = q(".elk-spread");
    spread.dataset.view = state.view;
    spread.style.setProperty("--elk-cardc", c.color);
    q('[data-half="L"]').hidden = state.view === "right";
    q('[data-half="R"]').hidden = state.view === "left";
    q(".elk-spine").hidden = state.view !== "spread";
    qa(".elk-seg button").forEach(b => b.setAttribute("aria-pressed", b.dataset.view === state.view ? "true" : "false"));
    q(".elk-stage").classList.toggle("elk-lit", state.light);
    q(".elk-light").setAttribute("aria-pressed", String(state.light));
    q("[data-light-txt]").textContent = state.light ? "Licht ausschalten" : "Licht einschalten";
    requestAnimationFrame(checkFit);
    q("[data-status]").hidden = true;
  }

  function checkFit() {
    if (state.view === "left") return;
    TEXTS.forEach(t => {
      clampPos(t.k); placeText(t.k);
      const el = outEl(t.k);
      // nur warnen, wenn die Box ihre Maximalhöhe erreicht hat und Text abgeschnitten wird
      const maxed = el.offsetHeight >= pageR().offsetHeight * .92 - 2;
      const over = maxed && el.scrollHeight > el.clientHeight + 1;
      q(`[data-warn="${t.k}"]`).hidden = !(state[t.k].text && over);
    });
  }

  // ---------- Druck-PDF ----------
  function loadImg(src) {
    return new Promise((ok, fail) => {
      const im = new Image(); im.crossOrigin = "anonymous";
      im.onload = () => ok(im); im.onerror = () => fail(new Error("Bild konnte nicht geladen werden"));
      im.src = src;
    });
  }
  function drawCover(ctx, im, w, h) {
    const sc = Math.max(w / im.naturalWidth, h / im.naturalHeight);
    const dw = im.naturalWidth * sc, dh = im.naturalHeight * sc;
    ctx.drawImage(im, (w - dw) / 2, (h - dh) / 2, dw, dh);
  }
  function wrapLines(ctx, text, maxW) {
    const out = [];
    text.split("\n").forEach(par => {
      let line = "";
      par.split(" ").forEach(word => {
        // sehr lange Wörter zeichenweise umbrechen, wie in der Vorschau
        while (ctx.measureText(word).width > maxW && word.length > 1) {
          let n = word.length - 1;
          while (n > 1 && ctx.measureText((line ? line + " " : "") + word.slice(0, n)).width > maxW) n--;
          if (line && ctx.measureText(line + " " + word.slice(0, n)).width > maxW) { out.push(line); line = ""; continue; }
          out.push((line ? line + " " : "") + word.slice(0, n)); line = ""; word = word.slice(n);
        }
        const test = line ? line + " " + word : word;
        if (ctx.measureText(test).width > maxW && line) { out.push(line); line = word; } else line = test;
      });
      out.push(line);
    });
    return out;
  }
  function drawPhoto(ctx, im, p, W, H) {
    const b = photoBox(p);
    ctx.drawImage(im, b.l / 100 * W, b.t / 100 * H, b.w / 100 * W, b.h / 100 * H);
  }
  async function renderPrintSide(s) {
    const W = mmToPx(PRINT.w), H = mmToPx(PRINT.h);
    const cv = document.createElement("canvas"); cv.width = W; cv.height = H;
    const ctx = cv.getContext("2d");
    const bg = state.bg[s], solid = solidOf(bg);
    ctx.fillStyle = solid ? solid.hex : "#FFFFFF";
    ctx.fillRect(0, 0, W, H);
    if (bg === "own") drawPhoto(ctx, await loadImg(state.photo[s].src), state.photo[s], W, H);
    else if (!solid) drawCover(ctx, await loadImg(tplUrl(tplOf(bg))), W, H);
    if (s === "R") {
      for (const t of TEXTS) {
        const cfg = state[t.k];
        if (!cfg.text.trim()) continue;
        const f = fontObj(cfg.font);
        const fs = cfg.size * t.factor * f.scale / 100 * W;
        await document.fonts.load(`${f.w} ${Math.round(fs)}px ${f.css}`);
        ctx.font = `${f.w} ${fs}px ${f.css}`;
        ctx.fillStyle = colorObj(cfg.color).hex;
        ctx.textAlign = "center"; ctx.textBaseline = "middle";
        const cx = state.pos[t.k].x / 100 * W, cy = state.pos[t.k].y / 100 * H, boxW = .86 * W;
        const lines = wrapLines(ctx, cfg.text, boxW), lh = fs * (t.multi ? 1.4 : t.k === "title" ? 1.05 : 1.15);
        const boxH = Math.min(lines.length * lh, .92 * H), top = cy - boxH / 2;
        ctx.save(); ctx.beginPath(); ctx.rect(cx - boxW / 2, top, boxW, boxH); ctx.clip();
        lines.forEach((ln, i) => ctx.fillText(ln, cx, top + lh * (i + .5)));
        ctx.restore();
      }
    }
    return cv;
  }
  function drawCropMarks(doc) {
    const { pageW: w, pageH: h, markLen: m } = PRINT, o = .15;
    doc.setDrawColor(0); doc.setLineWidth(.3);
    [[o, o, 1, 1], [w - o, o, -1, 1], [o, h - o, 1, -1], [w - o, h - o, -1, -1]].forEach(([x, y, dx, dy]) => {
      doc.line(x, y, x + dx * m, y); doc.line(x, y, x, y + dy * m);
    });
  }
  function drawRef(doc, ref, i) {
    doc.setFont("helvetica", "normal"); doc.setFontSize(7); doc.setTextColor(90);
    doc.text(`ÉLUMÉ Classic  ·  Ref. ${ref}  ·  Seite ${i + 1}/2 (${i ? "rechts" : "links"})`, PRINT.pageW / 2, PRINT.pageH - 8, { align: "center" });
  }
  async function buildPrintPDF(ref) {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({ unit: "mm", format: [PRINT.pageW, PRINT.pageH], orientation: "portrait", compress: true });
    for (const [i, s] of ["L", "R"].entries()) {
      if (i) doc.addPage([PRINT.pageW, PRINT.pageH], "portrait");
      const cv = await renderPrintSide(s);
      doc.addImage(cv.toDataURL("image/jpeg", .92), "JPEG", PRINT.x, PRINT.y, PRINT.w, PRINT.h);
      drawCropMarks(doc);
      drawRef(doc, ref, i);
    }
    doc.setProperties({ title: `ÉLUMÉ Classic Druckdaten ${ref}` });
    return doc.output("blob");
  }

  // ---------- Warenkorb ----------
  function alertStatus(errors, text) {
    const st = q("[data-status]");
    st.innerHTML = errors && errors.length
      ? `<strong>Bitte prüfe noch:</strong><ul>${errors.map(e => `<li>${esc(e)}</li>`).join("")}</ul>`
      : esc(text || "");
    st.hidden = false;
  }
  function validate() {
    checkFit();
    const errors = [];
    ["L", "R"].forEach(s => {
      const side = s === "L" ? "linke" : "rechte";
      if (state.bg[s] === "own" && !state.photo[s]) errors.push(s === "L" ? "Wähle ein Foto für die linke Seite." : "Wähle ein Foto für die rechte Seite oder einen anderen Hintergrund.");
      else if (state.bg[s] === "own" && !photoFits(state.photo[s])) errors.push(`Das Foto auf der ${side}n Seite füllt den Rahmen nicht ganz aus. Vergrößere oder verschiebe es.`);
    });
    if (!TEXTS.some(t => state[t.k].text.trim())) errors.push("Schreibe mindestens einen Text für die rechte Seite.");
    TEXTS.forEach(t => { if (!q(`[data-warn="${t.k}"]`).hidden) errors.push(`${t.name} passt nicht auf die Karte.`); });
    return errors;
  }
  const styleLabel = (k) => { const s = state[k]; return `${fontObj(s.font).name}, Größe ${s.size}, ${colorObj(s.color).name}`; };

  // Demo-Modus (Vorschau außerhalb des Shops): statt Warenkorb die Druckdatei und die Angaben anzeigen
  async function showDemo(ref, blob) {
    const pages = [];
    for (const s of ["L", "R"]) pages.push((await renderPrintSide(s)).toDataURL("image/jpeg", .8));
    const rows = [...form.querySelectorAll("[data-prop]")].filter(i => !i.disabled && i.dataset.prop !== "design")
      .map(i => `<dt>${esc(i.name.replace(/^properties\[|\]$/g, ""))}</dt><dd>${esc(i.value)}</dd>`).join("");
    const st = q("[data-status]");
    st.innerHTML = `<strong>Demo: So käme die Bestellung bei Euch an</strong>
      <dl class="elk-props">${rows}<dt>_Druckdatei</dt><dd>ELUME-Classic-${esc(ref)}.pdf (${Math.round(blob.size / 1024)} KB, 2 Seiten)</dd></dl>
      <div class="elk-demo-pages">${pages.map((src, i) => `<figure><div class="elk-demo-sheet"><img src="${src}" alt="Druckseite ${i ? "rechts" : "links"}"><span>ÉLUMÉ Classic · Ref. ${esc(ref)} · Seite ${i + 1}/2</span></div><figcaption>Seite ${i + 1}: ${i ? "rechts" : "links"}</figcaption></figure>`).join("")}</div>`;
    st.hidden = false;
  }

  const form = q("[data-elk-form]");
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const errors = validate();
    if (errors.length) { alertStatus(errors); return; }
    const btn = form.querySelector(".elk-cta"), label = btn.textContent;
    btn.disabled = true; btn.textContent = "Karte wird vorbereitet …";
    try {
      const ref = makeRef();
      const prop = (k, v) => { form.querySelector(`[data-prop="${k}"]`).value = v; };
      prop("ref", ref);
      prop("card", card().name);
      prop("bgL", state.bg.L === "own" ? `Eigenes Foto (${state.photo.L.name})` : bgLabel("L"));
      prop("bgR", state.bg.R === "own" ? `Eigenes Foto (${state.photo.R.name})` : bgLabel("R"));
      TEXTS.forEach(t => prop(t.k, state[t.k].text.trim() ? `${state[t.k].text} (${styleLabel(t.k)})` : ""));
      prop("design", JSON.stringify({ v: 2, ref, card: state.card, bg: state.bg,
        photo: Object.fromEntries(["L", "R"].map(s => [s, state.photo[s] && { scale: +state.photo[s].scale.toFixed(3), ox: +state.photo[s].ox.toFixed(2), oy: +state.photo[s].oy.toFixed(2) }])), title: state.title, sub: state.sub, msg: state.msg, pos: state.pos }));
      // leere Eigenschaften nicht mitschicken
      form.querySelectorAll("[data-prop]").forEach(inp => { inp.disabled = !inp.value; });

      const blob = await buildPrintPDF(ref);
      const file = new File([blob], `ELUME-Classic-${ref}.pdf`, { type: "application/pdf" });
      const dt = new DataTransfer(); dt.items.add(file);
      form.querySelector("[data-print-file]").files = dt.files;
      if (form.hasAttribute("data-demo")) { await showDemo(ref, blob); btn.disabled = false; btn.textContent = label; return; }
      btn.textContent = "Wird in den Warenkorb gelegt …";
      HTMLFormElement.prototype.submit.call(form);
    } catch (err) {
      console.error(err);
      btn.disabled = false; btn.textContent = label;
      alertStatus(null, "Die Karte konnte nicht vorbereitet werden. Bitte versuche es noch einmal oder wähle ein anderes Foto.");
    }
  });

  // ---------- Start ----------
  buildSide("L"); buildSide("R"); buildTexts();
  buildOptions(q('[data-opts="card"]'), CARDS, c => `<span class="elk-chip" style="background:${c.color}"></span><span>${c.name}</span>`,
    c => state.card === c.id, c => state.card = c.id, "elk-card-opt");
  TEXTS.forEach(({ k }) => enableDrag(k));
  qa(".elk-seg button").forEach(b => b.addEventListener("click", () => { state.view = b.dataset.view; update(); }));
  q(".elk-light").addEventListener("click", () => { state.light = !state.light; update(); });
  q("[data-reset-pos]").addEventListener("click", () => { state.pos = JSON.parse(JSON.stringify(DEFAULT_POS)); update(); });
  update();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => requestAnimationFrame(checkFit));
})();

/* Link „…#faq“ (z. B. aus dem Footer) springt zum FAQ-Abschnitt der Produktseite */
(function () {
  function toFaq() {
    if (location.hash !== "#faq") return;
    const el = document.querySelector('[id$="__faq_pR8wCf"]');
    if (!el) return;
    el.style.scrollMarginTop = "calc(var(--header-height, 80px) + 16px)";
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  window.addEventListener("hashchange", toFaq);
  if (document.readyState === "complete") toFaq(); else window.addEventListener("load", toFaq);
})();

/* Button „Jetzt gestalten“ mittig unter dem Produktbild, scrollt zum Konfigurator */
(function () {
  const target = document.getElementById("konfigurator");
  const grid = document.querySelector(".product");
  if (!target || !grid || !grid.querySelector(".product-gallery, product-gallery")) return;
  const wrap = document.createElement("div");
  wrap.className = "elk-gestalten";
  wrap.innerHTML = `<a href="#konfigurator" class="elk-gestalten-btn">Jetzt gestalten
    <svg class="elk-gestalten-arrow" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M7 1v11M2 7l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></a>`;
  wrap.querySelector("a").addEventListener("click", (e) => {
    e.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    history.replaceState(null, "", "#konfigurator");
  });
  // Desktop: direkt unter dem großen Bild (neben den Vorschaubildern), Handy: unter der Galerie
  const imageList = grid.querySelector(".product-gallery__image-list");
  const desktop = window.matchMedia("(min-width: 1000px)");
  const place = () => {
    if (desktop.matches && imageList) imageList.appendChild(wrap);
    else grid.appendChild(wrap);
  };
  place();
  desktop.addEventListener("change", place);
})();
